module.exports = __webpack_public_path__ + "static/media/img2-1.a760319b.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cebolla/soilcheck/mo/img2-1.png
// module id = 1421
// module chunks = 3